import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Calendar, User, Clock, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const blogs = [
  {
    id: 'modi-fuel',
    title: "Modi's Fuel Conservation Appeal and India's Electric Vehicle Moment",
    excerpt: "PM Modi's fuel conservation call is accelerating India's shift to electric vehicles. Discover what it means for Chennai commuters and how to ride smarter.",
    category: 'Electric Mobility',
    author: 'Nura Team',
    date: 'May 1, 2026',
    readTime: '5 min read',
    route: '/blog/pm-modi-fuel-conservation-india-electric-vehicles',
  },
  {
    id: 'urban-pollution',
    title: "Why Does the Morning Air Feel Different? The Truth About Urban Pollution",
    excerpt: "Transportation is one of the biggest contributors to urban air pollution. Here's what Chennai's streets look like when a city starts choosing better.",
    category: 'Sustainability',
    author: 'Nura Team',
    date: 'April 22, 2025',
    readTime: '5 min read',
    route: '/blog/urban-pollution',
  },
];

const BlogPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black">
      <Navbar />

      {/* Hero */}
      <section className="pt-32 pb-12 bg-black text-center px-4">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">
            A new era of ideas is charging up.
          </h1>
        </div>
      </section>

      {/* Blog Cards */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {blogs.map((blog) => (
          <div
            key={blog.id}
            onClick={() => navigate(blog.route)}
            className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden cursor-pointer hover:border-[#bceb39] hover:scale-[1.02] transition-all duration-300 group"
          >
            <div className="p-6 space-y-3">
              <span className="inline-block bg-[#bceb39] text-black text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-1">
                {blog.category}
              </span>
              <h2 className="text-white font-bold text-xl leading-snug group-hover:text-[#bceb39] transition-colors">
                {blog.title}
              </h2>
              <p className="text-gray-400 text-sm leading-relaxed line-clamp-3">{blog.excerpt}</p>
              <div className="flex flex-wrap gap-4 text-xs text-gray-500 pt-2">
                <span className="flex items-center gap-1"><User size={12} className="text-[#bceb39]" />{blog.author}</span>
                <span className="flex items-center gap-1"><Calendar size={12} className="text-[#bceb39]" />{blog.date}</span>
                <span className="flex items-center gap-1"><Clock size={12} className="text-[#bceb39]" />{blog.readTime}</span>
              </div>
              <div className="pt-2 flex items-center gap-2 text-[#bceb39] text-sm font-semibold">
                Read More <ArrowRight size={14} />
              </div>
            </div>
          </div>
        ))}
      </section>

      <Footer />
    </div>
  );
};

export default BlogPage;